import React from "react";
// import { motion } from "framer-motion"; 
import "../Usp/usp.scss";
import SectionTitle from '../../components/SectionTitle/SectionTitle';

// 👉 React Icons (Correct icons for your text)
import { 
  FaSmile, 
  FaTeeth, 
  FaTooth, 
  FaMicroscope 
} from "react-icons/fa";


// 👉 Updated USP DATA with correct icons
const uspData = [
   {
    icon: FaTeeth,
    text: "Top 1% Invisalign Provider"
  },
  {
    icon: FaSmile,
    text: "Orthodontic Smile Transformations"
  },
 
  {
    icon: FaTooth,
    text: "Advanced Implants & Grafting Cases"
  },
  {
    icon: FaMicroscope,
    text: "Microscope-Assisted RCTs"
  }
];


const USP = () => {
  return (
    <section id="usp" className="usp-section">
      <div className="container">
        <div className="usp-header text-center">
          <SectionTitle 
            subTitle="Celebrating Success"
            title="Counting Our Achievements"
          />
        </div>

        <div className="row">
          {uspData.map((usp, index) => (
            <div key={index} className="col-md-3 col-sm-6 text-center usp-box">

              {/* ICON */}
              <usp.icon className="usp-icon" size={30} />

              {/* TEXT */}
              <p className="usp-text">{usp.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};


// Counter Component
// const Counter = ({ target, isHappySmiles }) => {
//   const [count, setCount] = React.useState(0);
//   const targetValue = parseFloat(target.replace(/[^\d.-]/g, "")); 
//   const duration = isHappySmiles ? 500 : 2000;
//   const step = isHappySmiles ? 50 : 1;

//   React.useEffect(() => {
//     let start = 0;
//     const end = targetValue;
//     const stepTime = Math.abs(Math.floor(duration / (end / step)));

//     if (end <= 0) return;

//     const interval = setInterval(() => {
//       start += step;
//       setCount(start);
//       if (start >= end) {
//         clearInterval(interval);
//       }
//     }, stepTime);

//     return () => clearInterval(interval);
//   }, [targetValue, duration, step]);

//   return (
//     <motion.span>
//       {count}
//       {target.includes("+") || target.includes(".") ? target.replace(/[0-9]/g, "") : ""}
//     </motion.span>
//   );
// };

export default USP;
